export default {
  numbers: '' + 10,
  operations: 'times',
  decimals: false,
  related: false,
  questions: [],
  generate () {
    // create questions if needed
    // we have to have minimum and maximum numbers of each table so we start with the minimum, shuffle then add the extra when we have run out
    let questionTablesMin = this.shuffleArray([3, 4, 5, 6, 6, 7, 7, 8, 8, 9, 9, 11, 12, 12])
    const questionTablesExtra = [2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12]
    let multiplierTablesMin = this.shuffleArray(questionTablesMin)
    const multiplierTablesExtra = [2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6, 7, 7, 7, 8, 8, 8, 9, 9, 9, 10, 10, 10, 11, 11, 11, 12, 12, 12]
    let dupCount = 0
    do {
      if (questionTablesMin.length === 0) {
        questionTablesMin = questionTablesMin.concat(this.shuffleArray(questionTablesExtra))
      }
      if (multiplierTablesMin.length === 0) {
        multiplierTablesMin = multiplierTablesMin.concat(this.shuffleArray(multiplierTablesExtra))
      }
      const multiplicand = questionTablesMin.pop()
      const multiplier = multiplierTablesMin.pop()
      const sen = multiplicand + ' × ' + multiplier
      const senCheck = multiplier + ' × ' + multiplicand
      const answers = [{ answer: (multiplicand * multiplier), correct: true }]
      if (this.questions.filter(ques => ques.question === sen || ques.question === senCheck).length === 0) {
        this.questions.push({ question: sen, answers })
        dupCount = 0
      } else {
        dupCount++
        questionTablesMin.push(multiplicand)
        questionTablesMin = this.shuffleArray(questionTablesMin)
        multiplierTablesMin.push(multiplier)
        multiplierTablesMin = this.shuffleArray(multiplierTablesMin)
        if (dupCount >= 5) {
          multiplierTablesMin = multiplierTablesMin.concat(this.shuffleArray(multiplierTablesExtra))
        }
      }
    }
    while (this.questions.length < 25)
    this.questions = this.shuffleArray(this.questions)
  },
  relatedMultiplier (dec) {
    let items = [1]
    if (!this.related) {
      // do nothing
    } else if (dec) {
      items = [0.01, 0.1, 1, 10, 100]
    } else {
      items = [1, 10, 100]
    }
    const item = items[Math.floor(Math.random() * items.length)]
    return item
  },
  getQuestion (answerCount) {
    if (this.questions.length > 0) {
      return this.questions.pop()
    }
    let answers = []
    let sen = ''
    let oper = this.operations
    if (oper === 'mixed') {
      const op = Math.round(Math.random())
      if (op) {
        oper = 'times'
      } else {
        oper = 'divide'
      }
    }

    const targetNumberOptions = this.numbers.split(',')
    const multiplierTarget = this.relatedMultiplier(this.decimals)
    const targetNumber = parseFloat((multiplierTarget * parseInt(this.shuffleArray(targetNumberOptions)[0])).toFixed(4)) // the times table
    const multiplierRand = this.relatedMultiplier(this.decimals)

    
    const num = parseFloat((multiplierRand * (Math.floor(Math.random() * 11) + 2)).toFixed(4)) // 2 - 12
    const otherNum = parseFloat((targetNumber * num).toFixed(4)) // product


    if (oper === 'times') {
      // console.log('target num: ' + targetNumber)
      // console.log('num: ' + num)
      // console.log('othernum: ' + otherNum)
      answers.push({ answer: otherNum, correct: true })
      const ord = Math.round(Math.random())
      if (ord === 1) {
        sen += num + ' × ' + targetNumber
      } else {
        sen += targetNumber + ' × ' + num
      }

      if (answerCount > 1) {
        let wrongAnswers = []

        if (this.related) {
          if (this.decimals) {
            // ÷10
            const ans = otherNum / 10
            if (!wrongAnswers.includes(ans)) {
              wrongAnswers.push(ans)
            }

            // ÷100
            const ansd = otherNum / 100
            if (!wrongAnswers.includes(ansd)) {
              wrongAnswers.push(ansd)
            }
            // x10
            const ans1 = otherNum * 10
            if (!wrongAnswers.includes(ans1)) {
              wrongAnswers.push(ans1)
            }
            // x100
            const ans2 = otherNum * 100
            if (!wrongAnswers.includes(ans2)) {
              wrongAnswers.push(ans2)
            }
            // x2
            const ans3 = otherNum * 2
            if (!wrongAnswers.includes(ans3)) {
              wrongAnswers.push(ans3)
            }

            // ÷2
            const ans35 = otherNum / 2
            if (!wrongAnswers.includes(ans35)) {
              wrongAnswers.push(ans35)
            }
            // + 1 multiple

            const ans4 = otherNum + Math.round(targetNumber / multiplierTarget)
            if (!wrongAnswers.includes(ans4)) {
              wrongAnswers.push(ans4)
            }
            // - 1 multiple
            const ans5 = otherNum - Math.round(targetNumber / multiplierTarget)
            if (!wrongAnswers.includes(ans5) && (otherNum - Math.round(targetNumber / multiplierTarget)) > 0) {
              wrongAnswers.push(ans5)
            }
            // 5 random numbers between max(0, n - 10) and n+10
            const multiplierProduct = multiplierTarget * multiplierRand
            const baseAnswer = otherNum / multiplierProduct
            for (let i = 0; i < 5; i++) {
              const r = Math.floor(Math.random() * Math.floor(baseAnswer * 2)) + 1
              const ans = r * multiplierProduct
              if (!wrongAnswers.includes(ans) && baseAnswer !== r) {
                wrongAnswers.push(ans)
              }
            }
          } else {
            // if mulitplierTarger || multiplierRand > 1 => ÷10
            if (multiplierTarget > 1 || multiplierRand > 1) {
              const ans = otherNum / 10
              if (!wrongAnswers.includes(ans)) {
                wrongAnswers.push(ans)
                // console.log('ans: ' + ans)
              }
            }
            // x10
            const ans1 = otherNum * 10
            if (!wrongAnswers.includes(ans1)) {
              wrongAnswers.push(ans1)
              // console.log('ans1: ' + ans1)
            }
            // x100
            const ans2 = otherNum * 100
            if (!wrongAnswers.includes(ans2)) {
              wrongAnswers.push(ans2)
              // console.log('ans2: ' + ans2)
            }
            // x2
            const ans3 = otherNum * 2
            if (!wrongAnswers.includes(ans3)) {
              wrongAnswers.push(ans3)
              // console.log('ans3: ' + ans3)
            }
            // + 1 multiple

            const ans4 = otherNum + Math.round(targetNumber / multiplierTarget)
            if (!wrongAnswers.includes(ans4)) {
              wrongAnswers.push(ans4)
              // console.log('ans4: ' + ans4)
            }
            // - 1 multiple
            const ans5 = otherNum - Math.round(targetNumber / multiplierTarget)
            if (!wrongAnswers.includes(ans5) && (otherNum - Math.round(targetNumber / multiplierTarget)) > 0) {
              wrongAnswers.push(ans5)
              // console.log('ans5: ' + ans5)
            }
            // 5 random numbers between max(0, n - 10) and n+10

            for (let j = 0; j < 5; j++) {
              const a = Math.max(1, Math.round(otherNum) - Math.round(otherNum / multiplierTarget))
              const b = Math.round(otherNum + Math.round(otherNum / multiplierTarget))
              const anss = Math.floor(Math.random() * Math.floor(b - a)) + a
              if (!wrongAnswers.includes(anss) && otherNum !== anss) {
                wrongAnswers.push(anss)
                // console.log('anss: ' + anss)
              }
            }
          }
        } else {
          for (let i = 0; i < targetNumber + otherNum + 12; i++) {
            if (i !== otherNum) {
              wrongAnswers.push(i)
            }
          }
        }
        wrongAnswers = this.shuffleArray(wrongAnswers)
        for (let j = 0; j < answerCount - 1; j++) {
          answers.push({ answer: '' + wrongAnswers[j], correct: false })
        }
        answers = this.shuffleArray(answers)
      }
      return { question: sen, answers }
    } else { // divide
      answers.push({ answer: num, correct: true })
      sen = otherNum + ' ÷ ' + targetNumber
      // wrong answers
      if (answerCount > 1) {
        let wrongAnswers = []

        if (this.related) {
          if (this.decimals) {
            // ÷10
            const ans = num / 10
            if (!wrongAnswers.includes(ans)) {
              wrongAnswers.push(ans)
            }
            // ÷100
            const ansd = num / 100
            if (!wrongAnswers.includes(ansd)) {
              wrongAnswers.push(ansd)
            }
            // x10
            const ans1 = num * 10
            if (!wrongAnswers.includes(ans1)) {
              wrongAnswers.push(ans1)
            }
            // x100
            const ans2 = num * 100
            if (!wrongAnswers.includes(ans2)) {
              wrongAnswers.push(ans2)
            }
            // x2
            const ans3 = num * 2
            if (!wrongAnswers.includes(ans3)) {
              wrongAnswers.push(ans3)
            }

            // ÷2
            const ans35 = num / 2
            if (!wrongAnswers.includes(ans35)) {
              wrongAnswers.push(ans35)
            }
            // + 1 multiple

            // let ans4 = otherNum / Math.round(((targetNumber / multiplierTarget) + 1) * multiplierTarget)
            // let ans4 = (otherNum + multiplierTarget) / targetNumber
            // let ans4 = (otherNum + ((targetNumber / multiplierTarget) + 1)) / targetNumber
            const ans4 = ((num / multiplierRand) + 1) * multiplierRand
            if (!wrongAnswers.includes(ans4)) {
              wrongAnswers.push(ans4)
            }
            // - 1 multiple
            // let ans5 = otherNum / Math.max(1, Math.round(((targetNumber / multiplierTarget) - 1) * multiplierTarget))
            const ans5 = ((num / multiplierRand) - 1) * multiplierRand
            if (!wrongAnswers.includes(ans5) && ((num / multiplierRand) - 1) > 1) {
              wrongAnswers.push(ans5)
            }
            // 5 random numbers between max(0, n - 10) and n+10
            //                        let multiplierProduct = multiplierTarget * multiplierRand
            const baseAnswer = num / multiplierRand
            for (let k = 0; k < 5; k++) {
              const r = Math.floor(Math.random() * Math.floor(baseAnswer * 2)) + 1
              const ansss = r * multiplierRand
              if (!wrongAnswers.includes(ansss) && baseAnswer !== r) {
                wrongAnswers.push(ansss)
              }
            }
          } else { // !decimals
            // if mulitplierTarger || multiplierRand > 1 => ÷10
            if (multiplierTarget > 1 || multiplierRand > 1) {
              const ans = num / 10
              if (!wrongAnswers.includes(ans)) {
                wrongAnswers.push(ans)
              }
            }
            // x10
            const ans1 = num * 10
            if (!wrongAnswers.includes(ans1)) {
              wrongAnswers.push(ans1)
            }
            // x100
            const ans2 = num * 100
            if (!wrongAnswers.includes(ans2)) {
              wrongAnswers.push(ans2)
            }
            // x2
            const ans3 = num * 2
            if (!wrongAnswers.includes(ans3)) {
              wrongAnswers.push(ans3)
            }
            // + 1 multiple

            const ans4 = ((num / multiplierRand) + 1) * multiplierRand
            if (!wrongAnswers.includes(ans4)) {
              wrongAnswers.push(ans4)
            }
            // - 1 multiple
            const ans5 = ((num / multiplierRand) - 1) * multiplierRand
            if (!wrongAnswers.includes(ans5) && ((num / multiplierRand) - 1) > 1) {
              wrongAnswers.push(ans5)
            }
            // 5 random numbers between max(0, n - 10) and n+10

            for (let l = 0; l < 5; l++) {
              const b = Math.round(num / multiplierRand) * 2
              const s = Math.floor(Math.random() * Math.floor(b)) + 1
              const ans = s * multiplierRand
              if (!wrongAnswers.includes(ans) && num !== s * multiplierRand) {
                wrongAnswers.push(ans)
              }
            }
          }
        } else {
          for (let i = 0; i <= num + 12; i++) {
            if (i !== num) {
              wrongAnswers.push(i)
            }
          }
        }
        wrongAnswers = this.shuffleArray(wrongAnswers)
        for (let j = 0; j < answerCount - 1; j++) {
          answers.push({ answer: '' + wrongAnswers[j], correct: false })
        }
        answers = this.shuffleArray(answers)
      }
      return { question: sen, answers }
    }
  },
  shuffleArray (array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      const temp = array[i]
      array[i] = array[j]
      array[j] = temp
    }
    return array
  }
}
